export const ADSTERRA_SMARTLINK_URL =
  'https://www.profitablecpmratenetwork.com/ev3q8s1kr?key=af91ffa459312bf39cf9c290dd0ba520';

export const ADSTERRA_POPUNDER_SCRIPT_URL =
  'https://pl29064307.profitablecpmratenetwork.com/b4/01/47/b40147e802a4a62abfbf1382341e2bd8.js';

export const ADSTERRA_SOCIAL_BAR_SCRIPT_URL =
  'https://pl29064761.profitablecpmratenetwork.com/94/84/c3/9484c33878fe5b1e8461d55c11e057b9.js';

// Banner ad (invoke.js pattern)
export const ADSTERRA_BANNER_SCRIPT_URL =
  'https://pl29065137.profitablecpmratenetwork.com/fa3e6c152c172d2d904e65d699c53e6f/invoke.js';
export const ADSTERRA_BANNER_CONTAINER_ID = 'container-fa3e6c152c172d2d904e65d699c53e6f';

// Feature flags — change these without touching any other file
export const AD_FLAGS = {
  adsEnabled: true,
  adBreakThreshold: 3,       // songs before first/each ad break
  defaultAdMode: 'smartlink', // 'smartlink' | 'popunder' | 'social-bar'
  adCooldownMs: 2 * 60 * 1000, // 2 minutes
  maxAdBreaksPerHour: 6,
  socialBarEnabled: true,
  popunderEnabled: true,
};
